import React, { FC, ChangeEvent } from 'react'
import { RadioGroup } from '@chakra-ui/core'
import {
  DetailRowWithRadioButton
} from '@engyalo/storefront-components'
import {
  IProductPricedPerCollectionLevel3 as productLevel3
} from '@engyalo/storefront-types/lib/graphql/product'
import { IProductLevel3 } from '@engyalo/storefront-types/lib/plugins/model'
import { ILevel3Props } from './types'

export const RadioCustomization: FC<ILevel3Props> = ({
  customizations, customizationSelected, setCustomizationSelected, currency,
}: ILevel3Props) => {

  const radioSelected = (event: ChangeEvent<HTMLInputElement>): void => {
    if (event.target) {
      if (event.target.checked) {

        if (customizations) {
          const filteredData = customizations.filter((data) => {
            if (data) {
              return data.id === event.target.value
            }
            return false
          })

          if (filteredData[0]) {
            setCustomizationSelected({
              ...filteredData[0],
              quantity: 1
            } as IProductLevel3, true)
          }
        }
      }
    }
  }

  const getValue = (elementId: string | null): boolean => {
    if (elementId) {
      const value = customizationSelected[elementId]
      if (value) {
        return value.quantity === 1
      }
    }
    return false
  }

  if (customizations) {
    return (
      <RadioGroup>
        {
          customizations.map((level3: productLevel3 | null) => {

            if (level3) {

              const {
                id,
                name,
                price,
              } = level3

              let priceText = undefined
              if (price && price > 0) {
                priceText = `+ ${currency} ${price.toFixed(2)}`
              }

              if (id && name) {
                return (
                  <DetailRowWithRadioButton
                    key={id}
                    title={name}
                    subTitle={priceText}
                    name="radioCustomization"
                    value={id}
                    onChangeEvent={radioSelected}
                    checked={getValue(id)}
                  />
                )
              }
            }
            return null
          })
        }
      </RadioGroup>
    )
  }

  return null
}
